import { color } from '@morressier/ts';
import styled from 'styled-components';

export const ExhibitorCard = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  border-radius: 3px;
  border: 1px solid ${color('lightGrey')};
  position: relative;
  width: 100%;

  &:hover {
    border: 1px solid #8E949E;
    box-shadow: 0 0.5rem 0.5rem rgba(0,0,0,0.08), 0 10px 10px rgba(0,0,0,0.1)
  }
`;

export const ExhibitorBanner = styled.img`
  height: 96px;
  width: 100%;
  object-fit: cover;
  background-color: ${color('lightGrey')};
  color: transparent;
`;

export const ExhibitorLogo = styled.img`
  height: 40px;
  width: 40px;
  object-fit: cover;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  margin: 16px;
  position: absolute;
  top: 0;
  border: 4px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: transparent;
  background-color: ${color('lightGrey')};
`;

export const ExhibitorCardContent = styled.div`
  padding: 1rem;
  min-height: 176px;
  
  p:not(:last-child) {
    padding-bottom: 0.5rem;
  }
`;
